import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Copy, ImageOff, ListX } from "lucide-react";
import DuplicatesPanel from "@/components/admin/audit/DuplicatesPanel";
import MissingPanel from "@/components/admin/audit/MissingPanel";

const SECTIONS = [
    { id: "duplicates", label: "Dublikatë (Part №)", icon: Copy },
    { id: "usage", label: "Pa Usage / Cross-reference", icon: ListX },
    { id: "images", label: "Pa foto", icon: ImageOff },
];

export default function CatalogAuditTab() {
    const [section, setSection] = useState("duplicates");
    const [cats, setCats] = useState([]);
    const [categoryId, setCategoryId] = useState("");

    useEffect(() => { api.get("/categories").then(({ data }) => setCats(data)).catch(() => toast.error("Kategoritë nuk u ngarkuan")); }, []);
    const params = useCallback(() => (categoryId ? { category_id: categoryId } : {}), [categoryId]);

    return (
        <div className="space-y-5" data-testid="admin-audit-tab">
            <div className="flex flex-wrap items-end gap-3">
                <div className="min-w-[240px]">
                    <label className="label-kicker mb-1 block">Kategoria</label>
                    <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)} className="input-field" data-testid="audit-category-select">
                        <option value="">Të gjitha kategoritë</option>
                        {cats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                </div>
                <div className="inline-flex border border-slate-200 flex-wrap">
                    {SECTIONS.map(({ id, label, icon: Icon }) => (
                        <button key={id} onClick={() => setSection(id)} data-testid={`audit-section-${id}`}
                            className={`inline-flex items-center gap-1.5 px-3 py-2 text-xs font-mono font-bold uppercase ${section === id ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
                            <Icon className="w-3.5 h-3.5" /> {label}
                        </button>
                    ))}
                </div>
            </div>
            {section === "duplicates" && <DuplicatesPanel params={params} categoryId={categoryId} />}
            {section !== "duplicates" && <MissingPanel key={section} kind={section} params={params} categoryId={categoryId} />}
        </div>
    );
}
